<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
      content-class="overflow-hidden"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between ">
          <span>REPORTS <br v-if="$vuetify.breakpoint.name == 'xs'"> ({{ getSelectedDevice?.name }}, ID:{{ getSelectedDevice?.id }})</span>
          <div>
            <v-btn 
              :disabled="loading"
              outlined
              @click="hideReports"
              class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
              :x-large="$vuetify.breakpoint.name == 'xl'"
              :large="$vuetify.breakpoint.name == 'lg'"
            >
              <v-icon color="white">
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row no-gutters class="d-flex justify-center">
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-row no-gutters class="d-flex" :class="$vuetify.breakpoint.name != 'xs' ? 'justify-start' : 'justify-space-between'">
                <v-col class="col-6 col-xl-3 col-md-3 col-lg-3">
                  <v-dialog
                    ref="dialogOne"
                    v-model="modalDateOne"
                    :return-value.sync="dateOne"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="mt-4 mr-4"
                        outlined
                        v-model="dateOne"
                        label="Month"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="dateOne"
                      scrollable
                      type="month"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="modalDateOne = false"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialogOne.save(dateOne)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
                <v-col class="col-6 col-xl-3 col-md-3 col-lg-3">
                  <v-select
                    class="mt-4"
                    :disabled="loading"
                    outlined
                    v-model="selectedSensorType"
                    :items="selectedDeviceSensors"
                    multiple
                    item-text="sensorName"
                    item-value="sensorTypeId"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    label="Param"
                    persistent-hint
                    dense
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col class="col-12 mt-5 d-flex justify-space-around justify-center">
                  <div class="fix-height scroll" v-if="reportData.length > 0">
                    <v-data-table
                      disable-pagination
                      hide-default-footer
                      :headers="headersReports"
                      :items="reportData"
                      class="elevation-1">
                    </v-data-table>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="col-12 d-flex mt-6" :class="$vuetify.breakpoint.name != 'xs' ? 'justify-end' : 'justify-space-between'">
              <v-btn :disabled="loading || selectedSensorType.length == 0" depressed outlined 
                class="mr-4 text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                :x-large="$vuetify.breakpoint.name == 'xl'"
                :large="$vuetify.breakpoint.name == 'lg'" @click="loadReports" >
                Generate <br v-if="$vuetify.breakpoint.name == 'xs'"> Report
              </v-btn>
              <v-btn v-if="loading || selectedSensorType.length == 0" :disabled="loading || selectedSensorType.length == 0" depressed outlined
                class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                :x-large="$vuetify.breakpoint.name == 'xl'"
                :large="$vuetify.breakpoint.name == 'lg'" @click.stop="console.log('report')">
                Download <br v-if="$vuetify.breakpoint.name == 'xs'"> Reports
              </v-btn>
              <download-excel
                v-else 
                disabled
                :data="reportData"
                :fields="json_fields"
                :name="`${dateOne}report.xls`"
              >
                <v-btn depressed outlined 
                class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                :x-large="$vuetify.breakpoint.name == 'xl'"
                :large="$vuetify.breakpoint.name == 'lg'">
                  Download Report
                </v-btn>
              </download-excel>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

  import DownloadExcel from "vue-json-excel";
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    props: ['isShowDialog', 'device', 'getEvents'],
    name: 'Reports',
    data(){
      return {
        json_fields: {},
        jsonBaseFields:{
          ID: 'ObjectId',
          Address: 'ObjectAddress',
          DeviceType: 'SubType',
          DateTime: 'DateTime'/*,
          Temperature: '74',
          Sensor1: '75',
          Sensor2: '76'*/
        },
        selectedDeviceSensors: [],
        selectedSensorType: [],
        selectedSortedType: null,
        loading: false,
        modalDateOne: false,
        dateOne: new Date().toISOString().substring(0, 7),
        selectedDevices: null,
        reportTypes: [],
        selectedReportType: null,
        headersBaseReports: [
          {

            align: 'center',
            text: 'ID',
            sortable: true,
            value: 'ObjectId',
            width: '5%'
          },
          { 
            align: 'left',
            text: 'Address',
            sortable: true,
            value: 'ObjectAddress',
            width: '30%'
          },
          { 
            align: 'center',
            text: 'Device type',
            sortable: true,
            value: 'SubType',
            width: '10%'
          }
        ], 
        headersReports: [],
        reportData: [],
        ReportSubjectsTypesDto: []
      }
    },
    components:{
      DownloadExcel
    },
    computed:{
      ...mapGetters(['getSubjectCreationDatas', 'getDevicesData', 'getSubDeviceTypes', 'getDeviceTypes', 'getSelectedDevice']),
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      }
    },
    async mounted(){
      this.$root.$on('showAllReports', async (dvs) => {
        console.log('showAllReports')
        this.selectedDevices = []
        dvs.forEach(dv => {
          this.selectedDevices.push(dv)
        })
        await this.mountDevices()
        console.log(this.selectedDevices)
      })
      this.$root.$on('showReports', async (dv) => {
        console.log('showReports')
        this.selectedDevices = []
        this.selectedDevices.push(dv)
        await this.mountDevices()
        console.log(this.selectedDevices)
      })
    },
    methods:{
      ...mapActions(['getDeviceSensors', 'GetReport']),
      async loadReports(){
        this.$root.$emit('loading', "start")
        this.mountBaseHeaders()
        this.ReportSubjectsTypesDto = []
        const sensorTypesId = []

        this.headersReports.push({
          align: 'center',
          sortable: true,
          text: 'Date/Time',
          value: `DateTime`,
          width: '15%'
        })
        this.selectedSensorType.forEach(sTypeId => {
          this.selectedDeviceSensors.forEach(apiSensor => {
            if(apiSensor.sensorTypeId == sTypeId){
              sensorTypesId.push(apiSensor.sensorTypeId)
              this.headersReports.push({
                align: 'center',
                sortable: true,
                text: apiSensor.sensorName,
                value: `${apiSensor.sensorTypeId}`,
                width: '5%'
              })
            }
          })
        })
        this.reportData.forEach(device => {
          this.ReportSubjectsTypesDto.push({
            DeviceId: device.device.id,
            DateStart: `${this.dateOne}-01T00:00Z`,
            DateEnd:  new Date(new Date(this.dateOne).getFullYear(), new Date(this.dateOne).getMonth() + 1, +1).toISOString().substring(0, 10) + 'T23:59Z',
            SensorTypesId: sensorTypesId
          })
        })
        
        await this.GetReport({
          ReportSubjectsTypes: this.ReportSubjectsTypesDto
        })
        .then(res => {
          this.reportData = []
          const addedSensors = {}
          this.selectedSensorType.forEach(st => {
            addedSensors[st] = ''
          })

          res.reportParameters.sort((a,b) => new Date(a.dateTime) - new Date(b.dateTime)).forEach(report => {
            const device = this.getDevicesData.filter(d => d.id==report.deviceId)[0]
            const trueId = `000${report.deviceId}`
            const tRN = new Date(report.dateTime)
            const f = this.reportData.filter(rp => {
              const tRO = new Date(rp.dateTime)
              return tRO.getDay() == tRN.getDay() && tRO.getHours() == tRN.getHours() && tRO.getMinutes() == tRN.getMinutes()
            })
            if(f.length > 0){
              f[f.length-1][report.sensorTypeId] = report.sensorValue
            }
            else{
              this.reportData.push({
                ObjectId: `DVC${trueId.substring(trueId.length-3, trueId.length)}`,
                ObjectAddress: device.address.fullAddress,
                SubType: `${this.getDeviceTypes.filter(sb => sb.id == device.device.deviceTypeId)[0].name}+${this.getSubDeviceTypes.filter(sb => sb.id == device.subDevice.typeId)[0].name}`,
                device: device,
                dateTime: report.dateTime,
                DateTime: report.dateTime.split('.')[0].replace("T", " "),
                ...addedSensors
              })
              this.reportData[this.reportData.length -1][report.sensorTypeId] = report.sensorValue
            }
          })
          this.$root.$emit('loading', "end")
        })
        .catch(e => {
          console.log(e)
          this.$root.$emit('globalError', e.code)
          this.$root.$emit('loading', "end")
        })

        this.json_fields = {}

        this.headersReports.forEach(header => {
          this.json_fields[header.text] = header.value
        })
      },
      async mountDevices(){
        this.reportData = []
        this.selectedDevices.forEach(device => {
          const trueId = `000${device.id}`
          this.reportData.push({
            ObjectId: `DVC${trueId.substring(trueId.length-3, trueId.length)}`,
            ObjectAddress: device.address.fullAddress,
            SubType: `${this.getDeviceTypes.filter(sb => sb.id == device.device.deviceTypeId)[0].name}+${this.getSubDeviceTypes.filter(sb => sb.id == device.subDevice.typeId)[0].name}`,
            device: device
          })
        })
        if(this.reportData.length > 0){
          this.selectedDevices = []
          this.selectedDevices.push(this.reportData[0].device)
          await this.loadDeviceSensors()
        }
        this.mountBaseHeaders()
      },
      mountBaseHeaders(){
        this.headersReports = []
        this.headersBaseReports.forEach(reportHeader => {
          this.headersReports.push({
            align: reportHeader.align,
            text: reportHeader.text,
            sortable: reportHeader.sortable,
            value: reportHeader.value,
            width: reportHeader.width
          })
        })
      },
      async loadDeviceSensors(){
        this.$root.$emit('loading', "start")
        await this.selectedDevices.forEach(async (selectedDevice) => {
          await this.getDeviceSensors(selectedDevice.id)
          .then(result => {
            if(result.result.code == 0){
              this.selectedDeviceSensors = result.sensorTypesDtos
            }
            this.$root.$emit('loading', "end")
          })
          .catch(e => {
            console.log(e)
            this.$root.$emit('globalError', e.code)
            this.$root.$emit('loading', "end")
          })
        })
      },
      hideReports(){
        this.$emit('hideReports')
      },
    }
  }
</script>
<style>
.overflow-hidden{
  overflow-x:hidden;
}
</style>